import restaurantModalLoginInstance from '../../modalLoginInstance'
import restaurantInstance from '../../instance'

const updateTableSplit = (splitId, tableId, data, hasModalLogin = true) => {
  return (hasModalLogin ? restaurantModalLoginInstance : restaurantInstance)
    .put(`/tables/${tableId}/splits/${splitId}`, data)
}

export default updateTableSplit
